import { organizationsRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { OrganizationKeys } from './keys';

export const useGetOrganizationProfilePicture = (
  organizationId: number,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: OrganizationKeys.PROFILE_PICTURE(organizationId),
    queryFn: () => organizationsRepo.getProfilePictureById(organizationId),
    enabled,
  });
};
